module.exports = __webpack_public_path__ + "static/media/homepage-basket.2a8e29d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage-basket.jpg
// module id = 610
// module chunks = 0